/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import BaseWrapper from '../../../components/base-wrapper';

export default function save( props ) {
	const { className } = props;

	const wrapperClasses = classnames(
		className,
		'gutenify-team-item',
		'flex-col-item'
	);

	return (
		<div className={ wrapperClasses }>
			<BaseWrapper { ...props } name="gutenify/team-member">
				<InnerBlocks.Content />
			</BaseWrapper>
		</div>
	);
}

